(function() {

	const DEBUG = false;

	/**
	 * A custom logger that only outputs messages to the console if the DEBUG flag is true.
	 * Errors are always logged regardless of the DEBUG flag.
	 */
	const logger = {
		log:   (...args) => DEBUG && console.log('[App]', ...args),
		error: (...args) => console.error('[App]', ...args),
	};

	function registerServiceWorker() {
		if (!('serviceWorker' in navigator)) {
			logger.log('Service Worker not supported in this browser.');
			return;
		}

		navigator.serviceWorker.register('/sw.js', {type: 'module'})
				 .then(registration => {
					 logger.log('Service Worker registered successfully with scope:', registration.scope);

					 // The worker is analytics-only (no cached assets), so a new version
					 // needs no page reload — it skipWaiting()s and claims clients on its own.
					 // Update silently and never prompt the user.
					 registration.onupdatefound = () => {
						 logger.log('New service worker version found. Installing silently.');
					 };
				 })
				 .catch(error => {
					 logger.error('Service Worker registration failed:', error);
				 });
	}

	/**
	 * Location language switcher: toggle the menu on click, close on outside-click or Escape.
	 * Uses document-level delegation so it covers every [data-language-switcher] on the page.
	 */
	function initLanguageSwitchers() {
		const closeSwitcher = (switcher) => {
			switcher.querySelector('[data-language-switcher-menu]')?.classList.add('hidden');
			switcher.querySelector('[data-language-switcher-toggle]')?.setAttribute('aria-expanded', 'false');
		};

		document.addEventListener('click', (event) => {
			const toggle = event.target.closest('[data-language-switcher-toggle]');

			document.querySelectorAll('[data-language-switcher]').forEach((switcher) => {
				if (!toggle || !switcher.contains(toggle)) {
					closeSwitcher(switcher);
					return;
				}

				const menu = switcher.querySelector('[data-language-switcher-menu]');
				const open = menu.classList.toggle('hidden') === false;
				toggle.setAttribute('aria-expanded', String(open));
			});
		});

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				document.querySelectorAll('[data-language-switcher]').forEach(closeSwitcher);
			}
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		registerServiceWorker();
		initLanguageSwitchers();
	});

})();
